import {RecentAbstractView} from "./view/RecentAbstractView";
import {requestService} from "../../services/RequestService";
import {ApiRoutes} from "../../routes/ApiRoutes";
import {RecentPartnerRfpView} from "./view/RecentPartnerRfpView";
import {RecentMemberView} from "./view/RecentMemberView";
import {RecentUpdateDTO} from "./dto/RecentUpdateDTO";


export const RecentModelAPI = {

    /**
     * Fetches the recent activity history.
     * @returns {Promise<RecentAbstractView[]>} Promise resolving to an array of RecentAbstractView.
     */
    getHistory: async (): Promise<RecentAbstractView[]> => {

        const response = await requestService.get(ApiRoutes.REACT_APP_URL_RECENT_READ);
        return response.data.map((item: RecentAbstractView) => {
            if (item.type === 1) {
                return new RecentPartnerRfpView(item);
            } else if (item.type === 2) {
                return new RecentMemberView(item);
            }
            // For unknown types, return a basic RecentMemberView as fallback
            // since RecentAbstractView cannot be instantiated directly
            return new RecentMemberView(item);
        });
    },

    /**
     * Adds a recent activity entry.
     * @param request
     * @returns {Promise<boolean>} Promise resolving to true if the operation was successful.
     */
    addRecent: async (request: RecentUpdateDTO): Promise<boolean> => {

        const response = await requestService.post(ApiRoutes.REACT_APP_URL_RECENT_ADD, request);
        return response.data as boolean;
    },
}